import { UserModel } from '../data/models/UserModel'

/**
 * Rule:
 *   - RoleId exists → trust Role.IsAdminLike only, ignore SecurityLevel
 *   - RoleId is NULL → fall back to SecurityLevel === 3
 */
export function getIsAdminLike(profile: UserModel | null | undefined): boolean {
    if (profile?.RoleId != null) {
        return profile?.Role?.IsAdminLike === true
    }
    return profile?.SecurityLevel === 3
}

/**
 * Admins are implicitly manager-like.
 * Rule:
 *   - RoleId exists → trust Role.IsAdminLike or Role.IsManagerLike, ignore SecurityLevel
 *   - RoleId is NULL → fall back to SecurityLevel === 3
 */
export function getIsManagerLike(profile: UserModel | null | undefined): boolean {
    if (profile?.RoleId != null) {
        return profile?.Role?.IsAdminLike === true || profile?.Role?.IsManagerLike === true
    }
    return profile?.SecurityLevel === 3
}

/**
 * Same as getIsAdminLike but also grants access to IsSafetyAdmin users.
 * Used by activity log, email log, SMS log, and settings pages.
 */
export function getIsAdminLikeOrSafetyAdmin(profile: UserModel | null | undefined): boolean {
    return getIsAdminLike(profile) || profile?.IsSafetyAdmin === true
}
